import { Controller } from "stimulus"
import {PDFDocument, StandardFonts} from "pdf-lib"

export default class extends Controller {
  static targets = [
    "answer",
    "validateAnswers",
    "editAnswers",
    "form",
    "certificateRequired",
    "certificateRequiredPanel",
    "noCertificateRequiredPanel"
  ]

  static values = {
    title: String,
    fileName: String
  }

  connect() {
    this.disableSubmit()
  }

  disableSubmit() {
    const answered = this.answerTargets.filter(r => r.checked)
    const total =  this.answerTargets
    if (answered.length < total.length / 2) {
      this.validateAnswersTarget.setAttribute("disabled","true");
    } else {
      this.validateAnswersTarget.removeAttribute("disabled");
    }
  }

  validateAnswers() {
    // Disable answers
    this.answerTargets.forEach( answer => {
      answer.setAttribute("disabled","true");
      answer.parentElement.classList.add("disabled")
    })
    this.validateAnswersTarget.classList.add("d-none")
    this.editAnswersTarget.classList.remove("d-none")

    // Set send tab
    const yesResponses = this.answerTargets.filter(r => r.checked && r.value === "true")
    const certificateRequired = yesResponses.length > 0
    this.certificateRequiredTarget.value = certificateRequired
    if (certificateRequired) {
      this.noCertificateRequiredPanelTarget.classList.add("d-none")
      this.certificateRequiredPanelTarget.classList.remove("d-none")
    } else {
      this.noCertificateRequiredPanelTarget.classList.remove("d-none")
      this.certificateRequiredPanelTarget.classList.add("d-none")
    }
  }

  editAnswers() {
    // Enable answers
    this.answerTargets.forEach( answer => {
      answer.removeAttribute("disabled");
      answer.parentElement.classList.remove("disabled")
    })
    this.validateAnswersTarget.classList.remove("d-none")
    this.editAnswersTarget.classList.add("d-none")
  }

  download(event) {
    event.preventDefault()
    const creationInstant = new Date()
    const creationDate = creationInstant.toLocaleDateString('fr-FR')
    const creationHour = creationInstant
        .toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})
        .replace(':', 'h')

    this.generatePdf(creationDate, creationHour).then( blob => {
      this.downloadBlob(blob, `qs-sport-${creationDate}_${creationHour}.pdf`)
      this.formTarget.submit()
    });
  }

  async generatePdf(creationDate, creationHour) {
    const filePath = this.fileNameValue;
    const existingPdfBytes = await fetch(filePath).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // set pdf metadata
    pdfDoc.setTitle(this.titleValue);
    pdfDoc.setProducer('Dokeop');
    pdfDoc.setAuthor('Dokeop');

    const page1 = pdfDoc.getPages()[0]

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
    const drawText = (text, x, y, size = 11) => {
      page1.drawText(text, {x, y, size, font})
    }

    this.answerTargets.forEach( answer => {
      if (answer.checked && answer.value === 'true') {
        drawText('x',
            parseFloat(answer.dataset.xYes),
            parseFloat(answer.dataset.yYes),
            20);
      } else if (answer.checked && answer.value === 'false') {
        drawText('x',
            parseFloat(answer.dataset.xNo),
            parseFloat(answer.dataset.yNo),
            20);
      }
    });

    drawText('Questionnaire rempli sur www.dokeop.com le ' + `${creationDate} à ${creationHour}`,
        180,
        20, 8);

    const pdfBytes = await pdfDoc.save();

    return new Blob([pdfBytes], {type: 'application/pdf'});
  }

  downloadBlob(blob, fileName) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
  }
}
